import { getLocale } from '@/utils/native';

/**
 * 获取国家, 默认印尼
 */
const getCountry = () => {
    return getLocale()?.country || 'ID';
};

/**
 * 获取语言, 默认英语
 */
const getLanguage = () => {
    return getLocale()?.language || 'en';
};

export { getCountry, getLanguage };
